import Container from "react-bootstrap/Container";
import styled from "styled-components";
import { BOLD_FONT_WEIGHT, LG_PADDING, XL_FONT_SIZE } from "./StyleElement";

const handleSectionHeight = (height) => {
    switch (height) {
        case "full":
            return "100vh";
        case "above_full":
            return "150vh";
        case "more_than_full":
            return "170vh";
        default:
            return "";
    }
};

export const Section = styled.section`
    min-height: ${({ height }) => handleSectionHeight(height) || '768px'};
    display: flex;
    ${(props) =>
        props.center
            ? `justify-content: center;
            align-items: center;
            `
            : `padding: 120px 0;`}
`;
export const FlowSection = styled.section`
    min-height: ${({ height }) => handleSectionHeight(height) || '768px'};
    display: flex;
    ${(props) =>
    props.center
        ? `justify-content: center;
            align-items: center;
            `
        : `padding-top: 120px ;`}
`;

export const SectionContainer = styled(Container)`
    padding: 40px 0;
`;

const handleTitleAlign = (align) => {
    switch (align) {
        case "left":
            return "left";
        case "right":
            return "right";
        default:
            return "center";
    }
};

export const Title = styled.div`
    font-weight: ${BOLD_FONT_WEIGHT};
    padding-bottom: ${LG_PADDING};
    text-transform: uppercase;
    font-size: ${XL_FONT_SIZE};
    text-align: ${({ align }) => handleTitleAlign(align)};
`;
